import styled, { keyframes } from "styled-components";
import {RiMenu4Fill} from "react-icons/ri";
import {GiBowenKnot} from "react-icons/gi";
import { NavLink } from "react-router-dom";
import {FaDiscord, FaYoutube} from "react-icons/fa";
import {SiTelegram} from "react-icons/si";
import {MdEmail} from "react-icons/md";

export const IconWrapper = styled.a`
    border: 2px solid #fff;
    margin-left: 12px;
    border-radius: 50%;
    width: 50px;
    height: 50px;

    &:hover{
        opacity: 0.7;
    }
`;

export const Discord = styled(FaDiscord)`
    padding: 16px;
    cursor: pointer;
`;
export const Youtube = styled(FaYoutube)`
    padding: 16px;
    cursor: pointer;
`;
export const Telegram = styled(SiTelegram)`
    padding: 16px;
    cursor: pointer;
`;
export const Email = styled(MdEmail)`
    padding: 16px;
    cursor: pointer;
`;

export const Head = styled.header`
    width: 100%;
    height: 16px;
    position: fixed;
    z-index: 9999;
`;

export const OptWrapper = styled.div`
    margin: 0.5rem 1.5rem;
    display: flex;
`;

export const LogoWrapper = styled.div`
    flex: 1;
`;

export const Logo = styled(GiBowenKnot)`
    padding: 20px;

    @media (max-width: 700px){
        padding: 5px 0;
    }
`;

export const Hamburger = styled(RiMenu4Fill)`
    transition: all 0.5s ease-out;
    padding: 20px;
    cursor: pointer;
    transform: ${props => props.open ? 'rotate(-90deg)' : ''};

    @media (max-width: 700px){
        padding: 5px 0;
    }
`;

const show = keyframes`
    from{
        opacity: 0;
        right: -100vh;
    }to{
        opacity: 1;
    }
`;

/** 
    position: absolute;
    width: 100vw;
    right:0;
    top: 0;
    height: 100vh;
    background: transparent;
    background-image: -webkit-linear-gradient(-45deg, transparent 40%,rgb(164, 127, 47, 0.9) 40%,rgb(164, 127, 47, 0.9) 45%, rgb(24,30,45, 0.8) 45%);    
    right: ${props => (props.open ? 0 : -100)}vw;
    transition: all 0.5s ease-out;
    z-index: -1;
    display: flex;
    flex-direction: column-reverse;
*/

export const Menu = styled.div`
    position: absolute;
    width: 100vw;
    right:0;
    top: 0;
    transition: opacity 0.5s, visibility 0.5s ease-out;
    z-index: -1;
    opacity: ${props => (props.open ? 1 : 0)};
    visibility: ${props => (props.open ? '' : 'hidden')};
    height: 100vh;
    background: rgba(6,6,6,0.8);

    @media (min-width: 900px){
        background-image: linear-gradient( -45deg,rgba(6,6,6,0.8) 50%,rgba(217, 166, 56, 0.9) 50%,rgba(217, 166, 56, 0.9) 55%, transparent 55%);
    }
`;

export const FixedList = styled.div`
    height: calc(100% - ( 8rem + 80px));
    margin: 4rem;
    top: 80px;
    position: absolute;
    width: 100%;
    right: 0;
    border-right: 2px dashed #fff;
    transition: all 0.5s ease-out;

    @media (max-width: 900px){
        margin: 2rem;
    }
`;

export const LiWrapper = styled.div`
    position: absolute;
    right: 0;
`;

export const ListLi = styled(NavLink)`
    color: #fff;
    text-align:right;
    font-size: 32px;
    list-style: none;
    text-transform: uppercase;
    margin-right: 50px;
    margin-bottom: 32px;
    font-weight: 600;
    float: right;
    display: block;
    text-decoration: none;

    &:hover{
        opacity: 0.7;
    }

    &.active{
        color: #f0b83d;
        &::after {
            content: "⬤";
            color: #f0b83d;
            font-size: 20px;
            position: absolute;
            right: -10px;
            margin-top: 4px;
        }
        &:hover{
            opacity: 1;
        }
    }
`;

export const Contacts = styled.div`
    width: 100%;
    height: 100px;
    bottom: 0;
    right: 0;
    position: absolute;
    text-align: right;
    margin-right: 50px;
`;

export const Join = styled.div`
    font-size: 16px;
    font-weight: bold;
    color: #f0b83d;
    text-transform: uppercase;
    letter-spacing: 1px;
`;

export const ContactList = styled.div`
    display: flex;
    width: auto;
    right: 0;
    position: absolute;
    bottom: 0;
`;
